module.exports = __webpack_public_path__ + "static/media/nubecerca.09050c19.svg";